export default [
    {
        name: 'cadastro-usuario',
        path: 'usuario',
        redirect: 'usuario/index',
        component: () => import(/* webpackChunkName: 'cadastro-usuario' */ '@/views/cadastro/usuario/Index'),
        children: [
            {
                meta: { title: 'Lista de usuários' },
                name: 'cadastro-usuario-index',
                path: 'index',
                component: () => import(/* webpackChunkName: 'cadastro-usuario' */ '@/views/cadastro/usuario/List.vue'),
            },
            {
                meta: { title: 'Cadastro de usuário' },
                name: 'cadastro-usuario-create',
                path: 'create',
                component: () => import(/* webpackChunkName: 'cadastro-usuario' */ '@/views/cadastro/usuario/Form.vue'),
            },
            {
                meta: { title: 'Edição de usuário' },
                name: 'cadastro-usuario-edit',
                path: 'edit/:id',
                props: route => ({ id: parseInt(route.params.id) }),
                component: () => import(/* webpackChunkName: 'cadastro-usuario' */ '@/views/cadastro/usuario/Form.vue'),
            },
        ],
    },
]